import React from 'react';
import { PlaceholderPage } from '../../components/PlaceholderPage';

export const SecurityScamPrevention = () => (
  <PlaceholderPage
    category="Learn"
    title="Security & Scam Prevention"
    description="Stay safe on Block52 with our comprehensive security guide and scam prevention tips."
  />
);

export default SecurityScamPrevention;
